export const isInternalDomain = (): boolean => {
  const { hostname } = window.location
  return hostname.includes('localhost') || hostname.includes('cogia')
}

export const isTagline = process.env.REACT_APP_API_URL?.includes('tagline')
